module.exports = __webpack_public_path__ + "img/rock-paper-scissors.3f015cda.png";